<script>
  import Group from './group.svelte'
  export let reverse = false
  export let align = undefined
  export let xAlign = 'center'
  export let expand = undefined
  export let shrink = undefined
  export let basis = undefined
  export let width = undefined
  export let height = undefined
  export let minWidth = undefined
  export let maxWidth = undefined
  export let minHeight = undefined
  export let maxHeight = undefined
  export let backgroundColor = undefined
  export let wrap = undefined
  export let overflow = undefined
  export let overflowX = undefined
  export let overflowY = undefined

  const direction = 'row'
</script>

<Group 
  {direction} {reverse} {align} {xAlign} 
  {expand} {shrink} {basis} {backgroundColor}
  {width} {height} {minWidth} {maxWidth} {minHeight} {maxHeight} 
  {wrap} {overflow} {overflowX} {overflowY}
>
  <slot></slot>
</Group>